<section class="testimonials-wrapper">
  <!-- <div class="bg-shape"></div> -->
  <!-- <div class="header-content">
    <span class="badge">Testimonials</span>
    <h2>What WoW Health Users are Saying</h2>
    <p class="subtitle">
      Hear from members enjoying affordable, transparent care every day. 
      Transparent pricing is changing their healthcare experience.
    </p>
  </div> -->

  <div class="carousel-viewport">
    <div class="carousel-track" 
         [style.transform]="'translateX(calc(-' + currentIndex + ' * (var(--card-width) + 20px)))'">
      
      <div class="testimonial-card" *ngFor="let item of testimonials" 
      (touchstart)="onTouchStart($event)" 
      (touchmove)="onTouchMove($event)" 
      (touchend)="onTouchEnd()">
        <h3 class="quote-title">{{ item.quote }}</h3>
        <p class="quote-body">{{ item.body }}</p>
        
        <div class="author-info">
          <div class="avatar">
            <img [src]="item.avatarUrl" alt="{{ item.authorName }}" onerror="this.style.display='none'">
          </div>
          <div class="details">
            <span class="name">{{ item.authorName }}</span>
            <span class="role">{{ item.authorRole }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="pagination">
    <button class="dot" *ngFor="let dot of dots" [class.active]="dot === currentIndex" (click)="goToSlide(dot)"></button>
  </div>
</section>